/* claude-v2.js — shared behaviour for the claude-*-v2 sections.
   Staggered scroll reveal + pointer spotlight, both off under
   prefers-reduced-motion, both no-JS safe (nothing is hidden until this runs).
   Loaded synchronously by each v2 section; the guard makes re-execution a no-op. */
(function () {
  if (window.cv2Init) return;

  window.cv2Init = function (root) {
    if (!root || root.dataset.cv2Init) return;
    root.dataset.cv2Init = '1';

    var mm = window.matchMedia ? function (q) { return window.matchMedia(q).matches; } : function () { return false; };
    var reduce = mm('(prefers-reduced-motion: reduce)');
    var targets = root.querySelectorAll('[data-reveal]');

    if (root.dataset.animate === 'true' && !reduce && 'IntersectionObserver' in window && targets.length) {
      root.classList.add('cv2--anim');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      targets.forEach(function (el) { io.observe(el); });

      /* Safety net: if the observer never fires (some in-app browsers), reveal
         everything ~1s after the section enters the viewport. */
      var armed = false;
      function inView() { var r = root.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }
      function check() {
        if (armed || !inView()) return;
        armed = true;
        window.removeEventListener('scroll', check);
        setTimeout(function () {
          if (!root.querySelector('[data-reveal].is-in')) {
            targets.forEach(function (el) { el.classList.add('is-in'); });
          }
        }, 1000);
      }
      window.addEventListener('scroll', check, { passive: true });
      check();
    }

    if (!reduce && mm('(hover: hover)')) {
      root.querySelectorAll('.cv2__card').forEach(function (card) {
        card.addEventListener('pointermove', function (ev) {
          var r = card.getBoundingClientRect();
          card.style.setProperty('--mx', (ev.clientX - r.left) + 'px');
          card.style.setProperty('--my', (ev.clientY - r.top) + 'px');
        }, { passive: true });
      });
    }
  };

  document.querySelectorAll('[data-cv2]').forEach(window.cv2Init);
})();
